import React, { useState } from 'react';
import { Grid,Box,Typography} from '@mui/material';
import TeamDetail from '../TeamDetail/TeamDetail';
import AccordionLyt from '../../../../components/Layouts/AccordionLyt/AccordionLyt';


const TeamAndKrDetail = (props:any) => {
    // const navigate=useNavigate()
    let{obj,num,namee}=props  || {};
    const [showAdvanceOptions, setShowAdvanceOptions] = useState<boolean>(false);

    let{name,verticalKeyResultTeams}=obj  || {};
    // const[allKeyResults,setAllKeyResults]=useState<any[]>();

    // let{keyResults}=obj || {};
    // useEffect(() => {
    //   setAllKeyResults(verticalKeyResultTeams)
    // }, [verticalKeyResultTeams])

  return (  
    <Grid p={2} marginTop={1}>
        <AccordionLyt
                    collapse={setShowAdvanceOptions}
                    // title={`نتیجه کلیدی ${i + 1}`} 
                    title={namee === "WithOut" ? ` تیم ${num + 1}:` +  name : `نتیجه کلیدی ${num + 1}:` + name }
                    expanded={showAdvanceOptions}
                  >
    <Grid container boxShadow={4}  bgcolor={'#00385c'} borderRadius={4} p={2} marginTop={1}>
        <Grid item xs={12}  >
        <Grid container >
        <Grid item xs={12}  >
        <Box 
        display={'flex'} 
        width={'100%'}
        alignItems={'start'}
         flexDirection={'column'}
        minHeight={'90px'} 
        justifyContent={'center'}  > 
        <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
        {
          namee === "WithOut" ?
          <Typography  variant='body1' fontWeight={900} color={'#fff'}  fontSize={'15px'} >
             تیم :{name}
        </Typography> :
        <Typography  variant='body1' fontWeight={900} color={'#fff'}  fontSize={'15px'} >
             نتیجه {num + 1} :{name}
        </Typography>
        }
        
        </Box>
        </Box>
        </Grid>
      </Grid>
        </Grid>
        <Grid item xs={12}  >
         {
          verticalKeyResultTeams !== null && verticalKeyResultTeams !== undefined && verticalKeyResultTeams.length>0 &&  <Grid container  >
          <Grid item xs={12}  >
            <Grid container spacing={1} px={1} >
           {
            verticalKeyResultTeams && verticalKeyResultTeams.map((o:any,i:number)=>{
              return <Grid  item xs={12} sm={12}  >
                <Box width={'100%'} key={i}   >
                <TeamDetail kr={o}   
                item={o}
                num = {i}
                namee = {namee}
                />
              </Box>
              </Grid>
            })
          }
           </Grid> 
          </Grid>
         </Grid>
         }
        </Grid>
    </Grid>
        </AccordionLyt>
    </Grid>
  )
}

export default TeamAndKrDetail